import React from 'react';
import {Box, TextArea as NativeInput, FormControl} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import {defaultProps} from '../constants';
import {message} from '../../../utils/messages';

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
  isRequired?: boolean;
  numberOfLines?: number;
  maxLength?: number;
  onFocus?: (event: Event) => void;
  onContentSizeChange?: (e: {target: React.Component}) => void;
}

const TextArea = (props: Props) => {
  const {
    label,
    error,
    control,
    name,
    rules,
    isRequired,
    numberOfLines,
    maxLength,
    onContentSizeChange,
  } = props;
  const {field} = useController({
    control,
    defaultValue: '',
    name,
    rules,
  });

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const handleChangeText = (value: string) => {
    field.onChange(value);
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isInvalid={error != null} {...{isRequired}}>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <NativeInput
          {...defaultProps}
          value={field.value}
          autoCompleteType=""
          onChangeText={handleChangeText}
          {...{numberOfLines}}
          maxLength={maxLength}
          onContentSizeChange={onContentSizeChange}
        />
        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default TextArea;
